<template>
  <input 
    ref="inputRef"
    type="text"
    :value="formattedValue"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'
// import Currency from "currency.js";

export default {
  name: 'CurrencyInput',
  props: {
    value  : Number,   // Vue 2: value
    options: Object
  },
  setup (props) {
    const { formattedValue, inputRef } = useCurrencyInput(props.options)

    return { inputRef, formattedValue }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/app.scss';

  input {
    padding:.5em;
    width:8em;
    border-radius:.5em;
    font-weight:500;
    background-color: lighten($body-bg, 10%) !important;
    color: $body-color !important;
    border: 1px solid rgba($body-color, 0.2) !important;

    &:focus {
      background-color: lighten($body-bg, 15%) !important;
      color: $body-color !important;
      border-color: $primary !important;
      box-shadow: 0 0 0 0.2rem rgba($primary, 0.25) !important;
      outline: none;
    }

    &::placeholder {
      color: rgba($body-color, 0.5) !important;
    }
  }

</style>